import Constants from './Constants'
import NotifyActions from './NotifyActions'
import ItemActions from './ItemActions'

const STATUS = Constants.GET_TIMERS_STATUS
const GET = Constants.GET_TIMERS
const GET_ONE = Constants.GET_TIMER
const ADD = Constants.ADD_TIMER
const REMOVE = Constants.REMOVE_TIMER
const UPDATE = Constants.UPDATE_TIMER
const options = { 
  parentName : 'project', 
  itemsName : 'timers',
  actionTypeBase : 'TIMER', 
  parentIdKey : 'projectId', 
  humanItemName : 'Timer' 
}

const actions = ItemActions.create( options )

function start( parent, item ) {
  return function( dispatch, getState, api ) {
    const req = api.timer( item ).start()
    req
      .then( ( data ) => {
        console.log( data )
        dispatch( { type : UPDATE, itemId : typeof item === 'string' ? item : item.id, item : data } )
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( `Failed to Start ${options.humanItemName}`, err ) )
      } ) 
  }
}

function stop( parent, item ) {
  return function( dispatch, getState, api ) {
    const req = api.timer( item ).stop()
    req
      .then( ( data ) => {
        console.log( data )
        dispatch( { type : UPDATE, itemId : typeof item === 'string' ? item : item.id, item : data } )
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( `Failed to Stop ${options.humanItemName}`, err ) )
      } ) 
  }
}

module.exports = Object.assign( actions, {
  start,
  stop
} )
